import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export const isWhitelistOrganizationProgramsForSSOLogin = ({
  thirdPartyOrgId,
  programId,
}: {
  thirdPartyOrgId?: string;
  programId?: string;
} = {}) => {
  const whitelistOrganizationProgramsForSSOLogin = EnterpriseExperiments.get(
    'whitelistOrganizationProgramsForSSOLogin'
  );
  return thirdPartyOrgId
    ? !whitelistOrganizationProgramsForSSOLogin[thirdPartyOrgId] ||
        whitelistOrganizationProgramsForSSOLogin[thirdPartyOrgId].includes(programId)
    : false;
};
